/* @flow */

import type { TrackData, ManageSong, ManageInput, SongSingleTrackConfig } from './Common';
import GlobalManager from './GlobalManager';

export default class SongManager implements ManageSong {
  currentSongKey: string;
  tracks: Array<TrackData> = [];
  muteAll = false;

  constructor(input: ManageInput) {
    input.subscribeMenuKeyPress('KeyM', () => this.toggleMuteAll());
  }
  cleanup() {
    this.muteTracks(this.tracks.map(t => t.key));
  }

  toggleMuteAll() {
    this.muteAll = !this.muteAll;

    const { tracks, muteAll } = this;
    tracks.forEach(s => {
      if (muteAll) {
        s.elm.pause();
      } else {
        s.elm.play();
      }
    });
  }

  // helper funcs
  unloadSong() {
    const { tracks } = this;
    tracks.forEach(s => {
      s.elm.remove();
    });
    this.tracks = [];
  }
  addTrack(trackConfig: SongSingleTrackConfig) {
    const trackUrl = GlobalManager.config.assetsUrl + 'song/' + trackConfig.file;

    const audioElm = document.createElement('audio');
    audioElm.loop = true;
    audioElm.volume = 0;
    // $FlowFixMe
    document.body.appendChild(audioElm);
    const audioPromise: Promise<void> = new Promise((resolve, reject) => {
      audioElm.addEventListener('canplaythrough', () => resolve(), false);
      audioElm.src = trackUrl;
    });
    this.tracks.push({
      elm: audioElm,
      key: trackConfig.key,
      src: trackUrl,
      promise: audioPromise,
    });
  }

  // api
  loadSong(songKey: string) {
    if (this.currentSongKey !== songKey) {
      this.unloadSong();
    }

    this.currentSongKey = songKey;
    const songLevelConfig = GlobalManager.config.song[songKey];
    songLevelConfig.forEach(si => {
      this.addTrack(si);
    });

    const { tracks } = this;
    Promise.all(tracks.map(sv => sv.promise)).then(() => {
      tracks.forEach(s => {
        s.elm.play();
      });
    });
  }
  setTrackVolume(key: string, volume: number) {
    const song = this.tracks.filter(s => s.key === key)[0];
    if (song) {
      song.elm.volume = volume;
    } else {
      console.log('song not found:', key);
    }
  }
  setTracksVolume(trackKeys: Array<string>, volume: number) {
    trackKeys.forEach(key => this.setTrackVolume(key, volume));
  }
  muteTracks(trackKeys: Array<string>) {
    this.setTracksVolume(trackKeys, 0);
  }
  playTracks(trackKeys: Array<string>) {
    this.setTracksVolume(trackKeys, 1);
  }
}



// WEBPACK FOOTER //
// ./src/SongManager.js